// extracted by mini-css-extract-plugin
export default {"Dropdown-menu":"SmsStoppedText_Dropdown-menu__5qiVa","text":"SmsStoppedText_text__NnpE3"};